import React from 'react';
import clsx from 'clsx';

type CardProps = {
  type: string,
  children: ReactChildren,
};

const Card = ({ children, type }: CardProps) => (
  <section
    aria-label={`${type}-card`}
    className={clsx(
      'card tw-relative tw-shrink-0 tw-rounded-lg tw-flex tw-flex-col tw-justify-between tw-h-full tw-w-full',
      'tw-row-span-1',
    )}
  >
    {children}
  </section>
);

export default Card;
